import axios from 'axios';
import {backendHost} from '../../config';

export const postChangeOffer = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/promo/change-offer`, params);
};